import { confirmSignIn, signIn } from 'aws-amplify/auth';
import { currentSession } from 'aws-auth-lib';
import { ensureAuthSuccess } from '../utils/access';

const EMAIL_CODE_STEP = 'CONFIRM_SIGN_IN_WITH_EMAIL_CODE';
const FACTOR_SELECTION_STEP = 'CONTINUE_SIGN_IN_WITH_FIRST_FACTOR_SELECTION';

const isEmailCodeStep = (result) => result?.nextStep?.signInStep === EMAIL_CODE_STEP;

export const requestEmailOtp = async (email) => {
    let result = await signIn({
        username: email.trim(),
        options: {
            authFlowType: 'USER_AUTH',
            preferredChallenge: 'EMAIL_OTP'
        }
    });

    if (isEmailCodeStep(result)) return result;

    if (
        result?.nextStep?.signInStep === FACTOR_SELECTION_STEP &&
        result.nextStep.availableChallenges?.includes('EMAIL_OTP')
    ) {
        result = await confirmSignIn({ challengeResponse: 'EMAIL_OTP' });
        if (isEmailCodeStep(result)) return result;
    }

    throw new Error('EMAIL_OTP_UNAVAILABLE');
};

export const confirmEmailOtp = async (code) => {
    const result = await confirmSignIn({ challengeResponse: code.trim() });

    if (!result?.isSignedIn || result?.nextStep?.signInStep !== 'DONE') {
        throw new Error('EMAIL_OTP_SIGN_IN_INCOMPLETE');
    }

    const session = ensureAuthSuccess(await currentSession());
    if (!session?.tokens?.idToken) throw new Error('EMAIL_OTP_SESSION_UNAVAILABLE');

    return result;
};
